import { mapGetters } from 'vuex';
import _ from 'lodash';
import newSite from '@/payloads/new-site.json';

const queuedWork = {
  computed: {
    ...mapGetters([
      'currentSite',
      'editorLoader',
    ]),
  },
  methods: {
    async checkQueuedWork({ page }) {
      let item = page;
      const { queue = {}, _id } = this.currentSite;
      const items = queue[`${page.type}s`] || {};
      const queued = items[page._id];
      if (page._id && queued && typeof queued === 'string') {
        this.$store.dispatch('setGlobalValue', {
          item: this.editorLoader,
          key: 'page',
          value: true,
        });
        try {
          const { queuedItem } = await this.$lightning([{
            name: 'getQueuedItem',
            payload: {
              _id: page._id,
              siteId: _id,
              type: page.type,
            },
          }]);
          if (queuedItem) {
            this.$log.info('queuedItem: ', queuedItem);
            item = queuedItem;
          }
        } catch (e) {
          const message = e.message || e;
          this.$log.error(message);
          this.$store.dispatch('addNotification', {
            id: Date.now(),
            type: 'error',
            message,
          });
        } finally {
          this.$store.dispatch('setGlobalValue', {
            item: this.editorLoader,
            key: 'page',
            value: false,
          });
        }
      }
      return { item };
    },
    addToQueuedWork({ page }) {
      const site = this.currentSite;
      const { queue, lifecycle } = site;
      const { type } = page;
      const siteNotLive = lifecycle === 'design';
      if (siteNotLive && type === 'template') {
        // we do this to allow for users to use templates
        // before there site goes live. This way they can build
        // as they like with no limits (templates wouldn't be usable otherwise)
        return;
      }
      if (!queue) {
        // queue backwards compatibility checker
        this.$store.dispatch('setGlobalValue', {
          item: this.currentSite,
          key: 'queue',
          value: _.cloneDeep(newSite.queue),
        });
      }
      this.$store.dispatch('runStateFn', {
        fn() {
          site.queue[`${type}s`][page._id] = new Date().toISOString();
        },
      });
      this.$log.info('something was queued in state: ', queue);
    },
    removeFromQueuedWork({ page }) {
      const site = this.currentSite;
      const { queue } = site;
      const { type } = page;
      const list = `${type}s`;
      if (queue && queue[list] && queue[list][page._id]) {
        this.$store.dispatch('runStateFn', {
          fn() {
            delete site.queue[list][page._id];
          },
        });
        this.$log.info('something was deleted from queue: ', queue);
      }
    },
  },
};

export { queuedWork };



// WEBPACK FOOTER //
// ./src/mixins/queued-work.js